import { render, staticRenderFns } from "./school-selector.vue?vue&type=template&id=5fcc62f6"
import script from "./school-selector.vue?vue&type=script&lang=ts"
export * from "./school-selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports